import { createContext } from "react";

/** What `applySchedule` reads beyond the two lists: a scoped PowerSchool connector runs more. */
export interface ScheduleAuditConnector {
  connectorType: string;
  vars: Record<string, unknown>;
}

/**
 * Context rather than a prop so the Schedules panel, at its line cap, need not thread it through.
 * Null when nothing provides it, and the audit then reads `vars.tables` and `vars.schedules` alone.
 */
export const ScheduleAuditContext = createContext<ScheduleAuditConnector | null>(null);
